import RequestMaster from '../RequestMaster'

export default class RequestSeguimientoTrimestralInscripcion extends RequestMaster {

    constructor() {
        super()
        this.URL_BASE = this.URL_BASE + '/seguimiento-trimestral'
    }

    /**
     * Crea una subvencion
     *
     * @param {Int}      id
     * @param {FormData} params
     * @param {Function} callback
     * @param {Function} callbackError
     * @param {Function} callbackFinally
     */
    create(params, callback = () => { }, callbackError = () => { }, callbackFinally = () => { }) {
        const path = ""
        this.post(path, params, callback, callbackError, callbackFinally)
    }
}
